import {ReactElement} from 'react';
import {usePlayerTime} from '../../hooks';

interface CurrentTimeProps {
  render: (time: number) => ReactElement;
}

export function CurrentTime({render}: CurrentTimeProps) {
  const time = usePlayerTime();

  return render(time.frame);
}
